export default [
  {
    name: 'ProductsList',
    path: '/settings/products',
    component: () => import('pages/settings/products/ProductsList.vue')
  },
  {
    name: 'ProductsSingle',
    path: '/settings/products/:id',
    component: () => import('pages/settings/products/ProductsSingle.vue')
  }
]
